import React, { Suspense } from "react";
import { AssistanceTotem } from "@icarius-pages/assistanceTotem";
import { Fiscalization } from "@icarius-pages/fiscalization";
import { Login } from "@icarius-pages/";
import { Route, Switch } from "react-router-dom";
import Loader from "@icarius-common/loader";


const OTHER_ROUTES = [
  {
    path: "/fiscalization",
    component: Fiscalization,
  },
  {
    path: "/registerAssistanceTotem",
    component: AssistanceTotem,
  },
]

const OuterRoutes = () => {

  return (
    <Suspense fallback={<Loader open={true} />}>
      <Switch>
        {
          OTHER_ROUTES.map(route =>
            <Route
              exact
              key={route.path}
              path={route.path}
              component={route.component}
            />
          )
        }
        <Route component={Login} />
      </Switch>
    </Suspense>
  );
}

export default OuterRoutes;